import * as utils from '../utils/utils.js';
import * as userPerms from '../utils/userPerms.js';

export default class Header {
    constructor($scope) {
        this.$scope = $scope;
        this.user = null;
        this.siteSettings = siteSettings;
        this.imageVer = siteSettings.imageVersion;
        this.verticalScrollbarWidth = 0;
        this.activeContentId = 'vl-top-menu';
        this.menuIsOpen = false;
        this.signInUrl = utils.getSignInUrl(true);

        // Set the target URL for the logotype, and open it in a new tab if it's an external domain
        let currentRootUrl = window.location.protocol + '//' + window.location.hostname;
        this.logoTargetUrl = this.siteSettings.headerLogoTargetUrl;
        this.logoTargetUrlTarget =
            !this.logoTargetUrl.startsWith('http') || this.logoTargetUrl.startsWith(currentRootUrl)
                ? '_self'
                : '_blank';
    }

    $onInit() {
        this.fetchUserInfo();
        this.showICPInfoIfUserInChina();
    }

    addCustomUserProperties() {
        this.user.cdsid =
            this.user._au &&
            this.user._au.length > 0 &&
            this.user._au.toLowerCase().indexOf('@volvocars.com') > 0
                ? this.user._au.toLowerCase().replace(/@volvocars.com/, '')
                : 'anonymous';

        this.showAdminContent = userPerms.allowedToSeeAdminUILinks(this.user);
    }

    fetchUserInfo() {
        let currentUser = utils.getCurrentUser();

        if (currentUser !== null) {
            this.user = currentUser;
            this.addCustomUserProperties();
            this.hamburgerLinks =
                this.user === null
                    ? this.siteSettings.hamburgerLinks.filter(_ => _.requireSignIn === false)
                    : this.siteSettings.hamburgerLinks;
            return;
        }
    }

    showICPInfoIfUserInChina() {
        if (utils.isUserInChina()) {
            utils.showElement(document.getElementById('vl-footer-icp'));
        }
    }

    signOut(returnUrl) {
        window.localStorage.clear();
        window.sessionStorage.clear();

        let signOutUrl = '/account/logout';
        if (returnUrl && returnUrl !== '') {
            signOutUrl += '?returnUrl=' + returnUrl;
        }

        fetch(signOutUrl, {
            method: 'POST',
            credentials: 'include'
        })
            .then(function(response) {
                if (response.redirected) {
                    window.location.href = response.url;
                } else {
                    // Workaround for IE11 - otherwise page will not reload at all and
                    // sign in button will not appear. Reirecting to root seems to be safest 'fail'
                    window.location.href = '/';
                }
            })
            .catch(function(err) {
                utils.log('header', 'Failed to sign user out', false, 3, err);
            });
    }

    openMenu() {
        this.menuIsOpen = true;
        this.activeContentId = 'vl-top-menu';

        this.verticalScrollbarWidth =
            window.innerWidth - document.getElementsByTagName('html')[0].clientWidth;

        if (!document.body.classList.contains('vl-noscroll'))
            document.body.classList.add('vl-noscroll');

        document.body.style.width = `calc(100% - ${this.verticalScrollbarWidth}px`;
    }

    closeMenu() {
        this.menuIsOpen = false;

        if (document.body.classList.contains('vl-noscroll'))
            document.body.classList.remove('vl-noscroll');

        document.body.style.width = '';
    }

    switchContent(elemId) {
        this.activeContentId = elemId;
    }
}
